//core modules
import React, {Fragment} from "react";

//custom modules
import SubscriptionSteps from "./SubscriptionSteps";
import {useStepsContext} from "./context/stepsContext";
import SubscriptionPlans from "./SubscriptionPlans";
import SubscriptionCustomize from "./SubscriptionCustomize";
import SubscriptionBilling from "./SubscriptionBilling";
import SubscriptionConfirmation from "./SubscriptionConfirmation"

const SubscriptionContainer = (props) => {

    const steps = [
        'Plan',
        'Customize',
        'Pay',
        'Confirmation'
    ];

    const {currentStep, showLoader} = useStepsContext();
    if(showLoader){
        return (
            <Fragment>
                <div className={'billing-loader-container'}>
                    <div className={'billing-loader'} data-loading-text="Please wait...">
                    </div>
                </div>
            </Fragment>
        )
    }
    return (
        <Fragment>
            <div className={`wp-container`}>
                <div className={`wp-wrapper`}>
                    <div className={`subscription-title`}>
                        <span className="subscription-title-font">Subscribe to Cratio CRM in 4 easy steps</span>
                    </div>
                    <div className={`subscription-steps-wrapper`}>
                        <SubscriptionSteps
                            steps={steps}
                            wrapperClass={`subscription-step-wrapper`}
                            currentStep={currentStep}
                            withTicks={false}
                        />
                    </div>
                    {
                        currentStep === 1 && <SubscriptionPlans />
                    }
                    {
                        currentStep === 2 && <SubscriptionCustomize />
                    }
                    {
                        currentStep === 3 && <SubscriptionBilling />
                    }
                    {
                        currentStep === 4 && <SubscriptionConfirmation />
                    }
                </div>
            </div>
        </Fragment>
    );
}

export default SubscriptionContainer;
